// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i9rB","col":"styles_col__2rH0V"};